export const LossProtectionEvent = {
  LossProtectionTooltipView: 'loss_protection_tooltip_view',
  LossProtectionTooltipClick: 'loss_protection_tooltip_click',
} as const;

export interface LossProtectionEventDataType {
  [LossProtectionEvent.LossProtectionTooltipView]: {
    event_location: string; // asset_tab, order_form_page, market_carousel
  };
}
